import { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Button,
  IconButton,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/system";
import Checkbox from "@mui/material/Checkbox";
import { useDispatch, useSelector } from "react-redux";
import { updateBrowserPage as updateBrowserPagePublisher } from "../../store/slice/browserFilterSlicePublisher";
import { useAppSelector } from "../../store/hooks";

interface Proptype {
  isOpen: boolean;
  handleClose: () => void;
  modalName: string;
  getFilterdValues?: (e: string[]) => void;
  filterValues?: any;
  applyFilter?: (e: string[]) => void;
  appliedFilterValues?: string[];
  setFilters: any;
  setFilterDrawer?: any;
}

const ModalOneOfBrowsePublisher = (props: Proptype) => {
  const {
    isOpen,
    handleClose,
    modalName,
    getFilterdValues,
    filterValues,
    applyFilter,
    appliedFilterValues,
    setFilters,
    setFilterDrawer,
  } = props;
  const [filteredValues, setFilteredvalues] = useState<string[]>([]);
  // console.log("filteredvalues", filteredValues);
  const dispatch = useDispatch();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const consortiamaster_id = useAppSelector(
    (state) => state.customer.customerDetails?.consortiamaster_id,
  );

  const uniqueL1SubjectIds = [
    ...new Set(
      useAppSelector((state) => state.searchReducer.subjectL1Type) || [],
    ),
  ];
  useEffect(() => {
    setValues();
  }, [isOpen]);

  function setValues() {
    if (Array.isArray(appliedFilterValues))
      setFilteredvalues(appliedFilterValues);
  }

  const selectedValues = (data: string) => {
    // console.log("working", data);

    if (filteredValues.length === 0) {
      setFilteredvalues([data]);
    } else if (filteredValues.includes(data)) {
      setFilteredvalues(() => filteredValues.filter((e) => e !== data));
    } else {
      setFilteredvalues((prev) => [...prev, data]);
    }
  };

  const handleSubmit = () => {
    dispatch(updateBrowserPagePublisher(1));
    getFilterdValues && getFilterdValues(filteredValues);
    applyFilter && applyFilter(filteredValues);
    setFilteredvalues([]);
    handleClose();
    setFilterDrawer(false);
  };

  function handleCancel() {
    setFilteredvalues([]);
    handleClose();
  }

  function popupTitle() {
    return (
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Typography variant="h6" fontWeight={"600"} fontFamily="Lora">
            {modalName}
          </Typography>
        </div>
        <div>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
    );
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth={false}>
      {popupTitle()}

      <DialogContent sx={{ width: { xs: "100%", sm: 700 } }}>
        {Array.isArray(filterValues) &&
          filterValues
            ?.filter((item) => {
              if (item.val === "ONOS Journals") return false;
              if (item.val === "NAAS") {
                return (
                  uniqueL1SubjectIds.includes(5) || consortiamaster_id === 1874
                );
              }
              return true;
            })
            ?.map((data: any) => {
              const [key, value] = Object.entries(data)[0];
              // if (key === "NAAS" && consortiamaster_id !== 1874) return;
              return (
                <Stack
                  direction={"row"}
                  alignItems="center"
                  sx={{ gap: { xs: "10%", sm: "40%" } }}
                >
                  <Stack
                    direction={"row"}
                    alignItems="center"
                    minWidth={{ xs: "none", sm: 200 }}
                  >
                    <Checkbox
                      onClick={() => selectedValues(Object.keys(data)[0])}
                      checked={filteredValues?.includes(Object.keys(data)[0])}
                    />
                    <Tooltip title={isXs ? Object.keys(data)[0] : ""} arrow>
                      <Typography
                        sx={{
                          width: { xs: "80px", sm: "120px", md: "160px" }, // Fixed width for typography
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {key}
                      </Typography>
                    </Tooltip>
                  </Stack>
                  {/* @ts-ignore */}
                  <Typography>({Object.values(data)[0]})</Typography>
                </Stack>
              );
            })}

        {/* Buttons */}
        <Stack
          direction={"row"}
          alignItems="center"
          sx={{ gap: 2, marginBlock: 2 }}
        >
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ minWidth: { xs: 100, sm: 150 } }}
          >
            Apply
          </Button>
          <Button
            onClick={handleCancel}
            sx={{ minWidth: { xs: 100, sm: 150 }, color: "#111928" }}
          >
            Cancel
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ModalOneOfBrowsePublisher;
